import axios from './Axios';
import Cookies from 'universal-cookie';
import moment from 'moment';

const errorMessage = {
    401: "Autentificación incorrecta. Por favor, inténtalo nuevamente.",
    403: "No tienes permiso para ver esta sección.",
    415: "El usuario se encuentra activo en el sistema actualmente.",
    419: "El usuario no tiene permiso para esta sección.",
    default: "Ocurrió un problema al rescatar los datos desde el servidor."
};
const cookies = new Cookies();

async function SetHeaderBearer(token, expires = null) {
    if (token) {
        API.Cookie = token;
        if (expires) {
            var expiracionCookie = new Date(expires);
            cookies.set('asy_recaudador', token, { path: '/', expires: expiracionCookie, sameSite: 'none', secure: true, partitioned: true });
            API.ExpiracionCookie = moment(expires);
            try {
                localStorage.setItem('asy_recaudador', token);
                localStorage.setItem('asy_recaudador_exp', expires);
            } catch (e) {}
        } else {
            cookies.set('asy_recaudador', token, { path: '/', sameSite: 'none', secure: true, partitioned: true });
            try {
                localStorage.setItem('asy_recaudador', token);
            } catch (e) {}
        }
        try {
            sessionStorage.setItem('asy_recaudador', token);
        } catch (e) {}
    }
    axios.defaults.headers.common['Authorization'] = token ? "Bearer " + token : "";
}

function BorrarCookie() {
    API.Cookie = null;
    API.ExpiracionCookie = null;
    axios.defaults.headers.common['Authorization'] = null;
    cookies.remove('asy_recaudador', { path: '/', sameSite: 'none', secure: true, partitioned: true });
    try {
        localStorage.removeItem('asy_recaudador');
        localStorage.removeItem('asy_recaudador_exp');
        sessionStorage.removeItem('asy_recaudador');
    } catch (e) {}
}

async function Logout() {
    try {
        await Call("Home/Logout");
    } catch(e) { }
    BorrarCookie();
}

async function RevisarCookie() {
    if (API.Cookie) return;

    let token = cookies.get('asy_recaudador');
    let expires = null;

    if (!token) {
        try {
            token = localStorage.getItem('asy_recaudador');
            expires = localStorage.getItem('asy_recaudador_exp');
        } catch (e) {}
    }

    if (!token) {
        try {
            token = sessionStorage.getItem('asy_recaudador');
        } catch (e) {}
    }

    // Buscar authToken (sesión de usuario) en query params o hash de window.location
    if (!token) {
        try {
            const searchParams = new URLSearchParams(window.location.search);
            token = searchParams.get('authToken');

            if (!token && window.location.hash && window.location.hash.indexOf('?') >= 0) {
                const hashSearch = window.location.hash.substring(window.location.hash.indexOf('?'));
                token = new URLSearchParams(hashSearch).get('authToken');
            }

            if (!token && window.top !== window) {
                try {
                    token = new URLSearchParams(window.top.location.search).get('authToken');
                } catch (_) {}
            }

            // Si se recuperó authToken de la URL, limpiar el parámetro de la barra del navegador por seguridad
            if (token && window.history && window.history.replaceState) {
                try {
                    const cleanUrl = new URL(window.location.href);
                    cleanUrl.searchParams.delete('authToken');
                    window.history.replaceState({}, document.title, cleanUrl.toString());
                } catch (_) {}
            }
        } catch (e) {}
    }

    if (token) {
        await API.SetHeaderBearer(token, expires);
    }
}

async function Call(url, data) {
    if (API.ExpiracionCookie && API.ExpiracionCookie < moment()) {
        BorrarCookie();
    }
    var method = data ? 'post' : 'get';
    var xhr = axios[method](`${API.UrlBase}/${url}`, data)
        .then((response) => {
            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.headers) {
                let autenticate = error.response.headers["www-authenticate"];
                if (autenticate && autenticate.includes('Bearer error="invalid_token"')) {
                    // token inválido
                    BorrarCookie();
                }
            }
            var mensajeErrorFinal = "";
            try {
                var errorCode = error.status ? error.status : error.toString().substring(error.toString().lastIndexOf("code") + 5);
                mensajeErrorFinal = errorMessage[errorCode];
                mensajeErrorFinal = mensajeErrorFinal ? mensajeErrorFinal : errorMessage.default;
            } catch (exception) {
                mensajeErrorFinal = errorMessage.default;
            }
            try {
                return (Promise.reject(error.response.data.Mensaje || error.response.data.Message || mensajeErrorFinal));
            } catch {
                return (Promise.reject(mensajeErrorFinal));
            }
        });
    return xhr;
}

const API = {
    Call: (url, data = null) => Call(url, data),
    SetHeaderBearer: (token, expires) => SetHeaderBearer(token, expires),
    BorrarCookie: () => BorrarCookie(),
    Logout: () => Logout(),
    RevisarCookie: () => RevisarCookie(),
    MensajeError: (numero) => errorMessage[numero],
    ExpiracionCookie: null,
    Cookie: null,
    UrlBase: null
};

export default API;
